import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as Components from "../../../components/all";

import { useNavigate } from "react-router-dom";

import { HiOfficeBuilding } from "react-icons/hi";
import { BiSupport } from "react-icons/bi";

export default function SupportStaff() {
	const navigate = useNavigate();
	// eslint-disable-next-line no-unused-vars
	const [loading, setLoading] = useState(false);

	// Users Data
	var agentData = {
		totalAgents: 175,
		allAgents: [
			{
				id: 1,
				name: "Staff 1",
				status: "active",
			},
			{
				id: 2,
				name: "Staff 2",
				status: "active",
			},
			{
				id: 3,
				name: "Staff 3",
				status: "suspended",
			},
		],
	};

	// Search Feature
	const [filteredAgents, setFilteredAgents] = useState(agentData.allAgents);
	const search = (term) => {
		if (term === "") {
			setFilteredAgents(agentData.allAgents);
			return;
		}

		const filtered = agentData.allAgents.filter(
			(x) => x.name.toLowerCase().indexOf(term.toLowerCase()) > -1
		);
		setFilteredAgents(filtered);
	};

	// generate Password
	function generatePassword() {
		var chars =
			"0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
		var passwordLength = 12;
		var password = "";
		for (var i = 0; i <= passwordLength; i++) {
			var randomNumber = Math.floor(Math.random() * chars.length);
			password += chars.substring(randomNumber, randomNumber + 1);
		}

		setNewAgent((prev) => ({ ...prev, password: password }));
	}

	// New Admin
	const [newAgent, setNewAgent] = useState({
		name: null,
		ps: null,
		password: null,
	});

	const createNewAgent = () => {
		if (
			newAgent.name === null ||
			newAgent.ps === null ||
			newAgent.password === null
		) {
			alert("Fill all fields !");
			return;
		}

		if (newAgent.password.length < 8) {
			alert("Password must have atleast 8 characters !");
			return;
		}

		alert(newAgent.ps + "\n" + newAgent.name + "\n" + newAgent.password);
	};

	// Suspend User
	const suspendAgent = async (id) => {
		var choice = prompt("Press 'y' if you want to suspend the user:");
		if (choice === "y" || choice === "Y") {
		}
	};

	// Activate User
	const activateAgent = async (id) => {
		var choice = prompt("Press 'y' if you want to active the user:");
		if (choice === "y" || choice === "Y") {
		}
	};

	return loading === true ? (
		<Components.Loader />
	) : (
		<div
			className="SupportStaff
            overflow-x-hidden overflow-y-auto 
            h-full 
            w-full
            sm:p-3 md:p-5
            flex flex-row flex-wrap
            "
		>
			{/* LEFT CARDS ROW */}
			<div
				className="LEFT-CARDS 
				flex flex-col
				sm:flex-[1]
				sm:min-w-[420px] 
				max-sm:w-full
				"
			>
				{/* left top cards */}
				<div className="LEFT-TOP-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[1]">
					{/* card 1 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
                        min-h-[120px] 
                        sm:min-w-[300px] flex-1                    
                        rounded-md
                        p-5 m-2
                        bg-white 
                        flex flex-col
                        "
					>
						{/* heading */}
						<div className="flex items-center">
							<div
								className="
                            h-6 w-6 
                            flex items-center justify-center
                            rounded-full
                            bg-[#DBF6ED] 
                            text-[#8DBEAD]
                            "
							>
								<BiSupport />
							</div>

							<h1 className="ml-2 text-darker">Customer Support Agents</h1>
						</div>

						{/* data */}
						<div className="flex items-center justify-center mt-5">
							<h1 className="text-3xl font-medium tracking-tighter ml-5">
								{agentData.totalAgents.toLocaleString()}
							</h1>
							<p className="text-sm text-darker ml-2">Agents</p>
						</div>
					</div>
				</div>

				{/* left bottom cards */}
				<div className="LEFT-BOTTOM-CARDS flex flex-col sm:flex-row sm:items-stretch sm:justify-between sm:flex-wrap flex-[5]">
					{/* card 1 */}
					<div
						style={{
							boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
						}}
						className="
						min-h-[400px] sm:min-h-[520px] 
						sm:min-w-[400px] 
						flex-1 
						max-sm:max-w-full 
						p-5 m-2
						rounded-md
						bg-white 
						flex flex-col
						overflow-hidden
						"
					>
						{/* heading */}
						<div className="p-2 pt-0 w-full">
							<div className="flex items-center justify-between">
								<h1 className="text-xl">Create Support Account</h1>
							</div>
							<p className="text-dark text-sm">
								Create new customer support account for a parking space
							</p>
						</div>

						{/* data */}
						<div className="w-[80%] h-fit m-auto flex flex-col">
							<input
								type="text"
								placeholder="User Name"
								className="text-sm border border-[#CCCCCC] w-full rounded px-2 py-1 my-5 focus:outline-none"
								onChange={(e) =>
									setNewAgent((prev) => ({ ...prev, name: e.value }))
								}
								value={newAgent.name}
							/>

							<div className="flex border border-[#CCCCCC] rounded overflow-hidden">
								<input
									type="text"
									placeholder="Password"
									className="text-sm rounded px-2 py-1 focus:outline-none flex-1 
									max-sm:w-[70%]"
									onChange={(e) =>
										setNewAgent((prev) => ({ ...prev, password: e.value }))
									}
									value={newAgent.password}
								/>

								<button
									className="text-sm text-darker font-medium rounded   
									sm:px-2 sm:ml-2 focus:outline-none
									max-sm:w-[30%]
									max-sm:text-center
									"
									onClick={() => generatePassword()}
								>
									Generate
								</button>
							</div>

							{/* button */}
							<button
								className="mt-8 mx-auto bg-main w-[60%] px-5 py-1 rounded text-white font-medium
								duration-300 ease-in-out
                            	hover:opacity-70
								"
								onClick={() => createNewAgent()}
							>
								Create
							</button>
						</div>
					</div>
				</div>
			</div>

			{/* RIGHT CARDS ROW */}
			<div
				className="RIGHT-CARDS 
				flex flex-col 
			    sm:flex-[1.2]
				overflow-hidden
				sm:min-w-[500px] 
				max-sm:w-full
			"
			>
				{/* card 1 */}
				<div
					style={{
						boxShadow: "0px 2px 6px rgb(20 20 20 / 0.1)",
					}}
					className="
                    min-h-[380px] sm:min-h-[480px] h-full 
                    p-5 m-2
                    rounded-md
                    bg-white 
                    flex flex-col
                    overflow-auto
                    "
				>
					{/* heading */}
					<div className="p-2 py-0 w-full">
						<div className="flex items-center justify-between">
							<h1 className="text-xl">Search Support Agents</h1>
						</div>
					</div>

					{/* search */}
					<div
						className={`
						mb-4 mt-2 p-1 bg-gray-50 rounded
						`}
					>
						<div className="relative flex-1">
							<div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
								<svg
									className="w-5 h-5 text-gray-500"
									aria-hidden="true"
									fill="currentColor"
									viewBox="0 0 20 20"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fillRule="evenodd"
										d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
										clipRule="evenodd"
									></path>
								</svg>
							</div>
							<input
								type="text"
								className="w-full block p-1.5 pl-10 text-sm text-gray-900  border-gray-300 rounded bg-gray-50 focus:outline-none"
								placeholder="Search for agents"
								onChange={(e) => search(e.target.value)}
							/>
						</div>
					</div>

					{/* data */}
					<div className="max-h-[calc(100vh)] 2xl:max-h-[calc(100vh-220px)] flex-1 overflow-y-auto">
						{/* table */}
						<div className="h-fit w-full overflow-y-hidden overflow-x-auto shadow-md sm:rounded">
							<div className="overflow-hidden min-w-max">
								<table className="w-full text-sm text-left text-gray-500">
									{/* head */}
									<thead className="text-xs text-gray-700 uppercase bg-gray-50">
										<tr>
											<th scope="col" className="px-6 py-3">
												Name
											</th>
											<th scope="col" className="px-6 py-3">
												Status
											</th>
											<th scope="col" className="pl-12 pr-3 py-3 text-center">
												Actions
											</th>
										</tr>
									</thead>

									{/* body */}
									<tbody className="">
										{filteredAgents.map(({ id, name, status }, index) => (
											<tr
												key={index}
												className="bg-white border-b hover:bg-gray-50"
											>
												<td className="px-6 py-4 font-medium text-darker whitespace-nowrap">
													{name}
												</td>

												<td className="px-6 py-4 capitalize">{status}</td>

												<td className="py-4 flex justify-end">
													<button
														className={`px-3 py-0.5 
                                                            text-xs text-white
                                                        ${
																													status.toLowerCase() ===
																													"active"
																														? "bg-yellow-400"
																														: "bg-green-400"
																												} 
                                                        font-medium 
                                                        rounded-full
                                                        duration-200 ease-out
                                                        hover:opacity-70
                                                        cursor-pointer`}
														onClick={() => {
															if (status.toLowerCase() === "active") {
																suspendAgent(id);
															} else {
																activateAgent(id);
															}
														}}
													>
														{status.toLowerCase() === "active"
															? "Suspend"
															: "Activate"}
													</button>

													<button
														className={`ml-2 px-3 py-0.5 
                                                            text-xs text-white
                                                            font-medium 
                                                            rounded-full
                                                            duration-200 ease-out
                                                            hover:opacity-70
                                                            bg-main
                                                            cursor-pointer`}
														onClick={() => {
															navigate(`passwordreset/${id}`);
														}}
													>
														Reset Password
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
